import React from 'react';
import './SocialIconsMenu.scss';
import { Link } from '../../organisms/link';
import Linkedin from '../../atoms/static-icons/linkedin';
import Facebook from '../../atoms/static-icons/facebook';
import Instagram from '../../atoms/static-icons/instagram';

const SocialIconsMenu = () => {
  return (
    <>
      <Link
        className='social-icon'
        to={'https://it.linkedin.com/company/cattolicageneraliitalia/'}
        title={'Cattolica su LinkedIn'}
      >
        <Linkedin />
      </Link>
      <Link
        className='social-icon'
        to={'https://www.facebook.com/Cattolica.GeneraliItalia/'}
        title={'Cattolica su Facebook'}
      >
        <Facebook />
      </Link>
      <Link
        className='social-icon'
        to={'https://www.instagram.com/cattolica.generaliitalia/'}
        title={'Cattolica su Instagram'}
      >
        <Instagram />
      </Link>
    </>
  );
};

export default SocialIconsMenu;
